import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { campusServices } from '../campus.service';
import { BaseCacheService } from './base-cache';

@Injectable({
  providedIn: 'root'
})
export class CampusCacheService extends BaseCacheService<any> {
  constructor(private campusService: campusServices) {
    super();
  }

  protected fetchApiData(): Observable<any[]> {
    return this.campusService.get();
  }
}
